<template>
  <!--
    作者：kmdshop
    时间：2020-06-04
    描述：插件中心-金币商城
  -->
  <div>
    <!--区域代理-->
    <Regionagent v-if="activeName == 'regionagent'"></Regionagent>
    
    <!--区域树-->
    <Regiontree v-if="activeName == 'regiontree'"></Regiontree>

    <!--设置-->
    <Setting v-if="activeName == 'setting'"></Setting>

  </div>
</template>
<script>
import bus from '@/utils/eventBus.js';
import Regionagent from './regionagent/index';
import Regiontree from './regiontree/index';
import Setting from './setting/index';

export default {
  components: {
    Regionagent,
    Regiontree,
    Setting
  },
  data() {
    return {
      /*参数*/
      param: {},
      /*当前选中*/
      activeName: 'regionagent',
      /*切换数组原始数据*/
      sourceList: [
        {
          key: 'regionagent',
          value: '区域代理管理',
          path:'/plus/regionagent/regionagent/index'
        },
        {
          key: 'regiontree',
          value: '区域树',
          path:'/plus/regionagent/regiontree/index'
        },
        {
          key: 'setting',
          value: '设置',
          path:'/plus/regionagent/setting/index'
        }
      ],
      /*权限筛选后的数据*/
      tabList:[],
    };
  },
  created() {

    this.tabList=this.authFilter();

    if(this.tabList.length>0){
      this.activeName=this.tabList[0].key;
    }

    if (this.$route.query.type != null) {
      this.activeName = this.$route.query.type;
    }

    /*监听传插件的值*/
    bus.$on('activeValue', res => {
      this.activeName = res;
    });

    //发送类别切换
    let params = {
      active: this.activeName,
      list: this.tabList,
      tab_type: 'regionagent'
    };
    bus.$emit('tabData', params);
  },
  beforeDestroy() {
    //发送类别切换
    bus.$emit('tabData', { active: null, tab_type: 'regionagent', list: [] });
    bus.$off('activeValue');
  },
  methods: {

    /*权限过滤*/
    authFilter(){
      let list=[];
      for(let i=0;i<this.sourceList.length;i++){
        let item=this.sourceList[i];
        if(this.$filter.isAuth(item.path)){
          list.push(item);
        }
      }
      return list;
    },

  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/regionagent/index.vue